import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { User } from '../../models/user';
import { distinctUntilChanged, map } from 'rxjs';
import { AuthService } from '../../services/auth.service';
import { SideBarService } from '../../services/sidebar.service';
import { ManualService } from '../../services/manual-service';

@Component({
  selector: 'app-menu',
  standalone: false,
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.css'
})

export class MenuComponent {

  //userData: User;
  //isSuperAdmin: boolean = false;
  authService = inject(AuthService);
  menuCode: string = "";
  
  constructor(
    private router: Router,
    //private authStore: Store<{authRdc: any}>,
    private menuStore: Store<{menuRdc: any}>,
    private sideBarService: SideBarService,
    private manualService: ManualService
  ) { 
    /*this.userData = new User();
    this.authStore.pipe(
      select('authRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        user: state.user,
        isSuperAdmin: state.isSuperAdmin
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ user, isSuperAdmin }) => {
    this.userData = JSON.parse(JSON.stringify(user));
    this.isSuperAdmin = isSuperAdmin;
    });*/
    this.menuStore.pipe(
      select('menuRdc'),
      map(state => ({ // filtra cuando cambian las propiedades que se usan en este componente
        menuCode: state.menuCode,
      })),
      // evita repeticiones
      distinctUntilChanged((prev, curr) =>
        JSON.stringify(prev) === JSON.stringify(curr)
      )
    ).subscribe(({ menuCode }) => {
      this.menuCode = menuCode;
    });
  }

  isSuperAdmin(){
    return this.authService.isSuperAdmin();
  }
  isAdmin(){
    return this.authService.isAdmin();
  }
  isUser(){
    return this.authService.isRol('ROL_USER');
  }
  isAuthorizer(){
    return this.authService.isRol('ROL_AUT');
  }


  goToCompanies(){
    this.router.navigate(['/companies']);
    this.toggleDrawer();
  }
  goToNewCompany(){
    this.router.navigate(['companies/add']);
    this.toggleDrawer();
  }

  goToAdminCompany(){
    this.router.navigate(['/adminCompany']);
    this.toggleDrawer();
  }

  goToUsers(){
    this.router.navigate(['/users']);
    this.toggleDrawer();
  }

  goToNewUser(){
    this.router.navigate(['users/create']);
    this.toggleDrawer();
  }

  goToListOffer(){
    this.router.navigate(['/offers']);
    this.toggleDrawer();
  }

  goToNewOffer(){
    this.router.navigate(['offers/create']);
    this.toggleDrawer();
  }

  goToUploadEmployee(){
    this.router.navigate(['employee/upload']);
    this.toggleDrawer();
  }

  goToListEmployee(){
    this.router.navigate(['/employee']);
    this.toggleDrawer();
  }

  goToListPositions(){
    this.router.navigate(['/positions']);
    this.toggleDrawer();
  }

  goToListAreas(){
    this.router.navigate(['/areas']);
    this.toggleDrawer();
  }
  addArea(){
    this.router.navigate(['areas/create']);
    this.toggleDrawer();
  }

  goToListDivisions(){
    this.router.navigate(['/divisions']);
    this.toggleDrawer();
  }
  addDivision(){
    this.router.navigate(['divisions/create']);
    this.toggleDrawer();
  }

  goToListParameters(){
    this.router.navigate(['/parameters']);
    this.toggleDrawer();
  }
  /*addParameter(){
    
  }*/

  goToListBenefetis(){
    this.router.navigate(['/benefitsGroup']);
    this.toggleDrawer();
  }
  addBenefitsGroup(){
    this.router.navigate(['benefitsGroup/create']);
  }

  goToListSignatures(){
    this.router.navigate(['/signatures']);
    this.toggleDrawer();
  }
  addSignatures(){
    //this.router.navigate(['/signatures/edit', 0]);
    this.router.navigate(['signatures/create']);
    this.toggleDrawer();
  }

  goToListRequestedSignatures(){
    this.router.navigate(['/requestedSignatures']);
    this.toggleDrawer();
  }

  goToBudgetCalculation(){
    this.router.navigate(['/budgetCalculation']);
    this.toggleDrawer();
  }

  goToHolidaysGroup(){
    this.router.navigate(['/holidays']);
    this.toggleDrawer();
  }
  addHolidaysGroup(){
    //this.router.navigate(['/holidays/edit', 0]);
    this.router.navigate(['holidays/create']);
    this.toggleDrawer();
  }

  goToListBenefitCatalog(){
    this.router.navigate(['/benefitsCatalog']);
    this.toggleDrawer();
  }
  addBenefitCatalog(){
    this.router.navigate(['benefitsCatalog/create']);
    this.toggleDrawer();
  }

  goToListWithholdings(){
    this.router.navigate(['/withholdingsGroup']);
    this.toggleDrawer();
  }
  addWithholdingsGroup(){
    this.router.navigate(['withholdingsGroup/create']);
    this.toggleDrawer();
  }

  goToListcostsPerEmployeeGroup(){
    this.router.navigate(['/costsPerEmployeeGroup']);
    this.toggleDrawer();
  }
  addcostsPerEmployeeGroup(){
    this.router.navigate(['costsPerEmployeeGroup/create']);
    this.toggleDrawer();
  }

  goToListCostsPerEmployeeCatalog(){
    this.router.navigate(['/costsPerEmployeesCatalog']);
    this.toggleDrawer();
  }
  addCostsPerEmployeeCatalog(){
    this.router.navigate(['costsPerEmployeesCatalog/create']);
    this.toggleDrawer();
  }

  goToListWithholdingCatalog(){
    this.router.navigate(['/withholdingsCatalog']);
    this.toggleDrawer();
  }
  addWithholdingCatalog(){
    this.router.navigate(['withholdingsCatalog/create']);
    this.toggleDrawer();
  }

  toggleDrawer() {
    this.sideBarService.toggle();
  }


  goToListFormulaGroup(){
    this.router.navigate(['/formulasGroup']);
    this.toggleDrawer();
  }
  addFormulaGroup(){
    this.router.navigate(['formulasGroup/create']);
    this.toggleDrawer();
  }

  goToListVariableCatalog(){
    this.router.navigate(['/variablesCatalog']);
    this.toggleDrawer();
  }
  addVariableCatalog(){
    this.router.navigate(['variablesCatalog/create']);
    this.toggleDrawer();
  }

  goToListObjectCatalog(){
    this.router.navigate(['/objectsCatalog']);
    this.toggleDrawer();
  }
  addObjectCatalog(){
    this.router.navigate(['objectsCatalog/create']);
    this.toggleDrawer();
  }

  downloadManualAdmin(){
    this.downloadManual('MANUAL_ADMIN');
  }
  
  downloadManualUser(){
    this.downloadManual('MANUAL_USER');
  }
  
  downloadManualSignature(){
    this.downloadManual('MANUAL_SIGNATURE');
  }
  
  downloadManualFormulaExample(){
    this.downloadManual('MANUAL_FORMULA_EXAMPLE');
  }
  
  downloadManual(type: string): void {
    //this.loading = true;
    this.manualService.downloadManual(type).subscribe((response: Blob) => {
      const fileURL = URL.createObjectURL(response);
      //this.loading = false;
      window.open(fileURL, '_blank');
    });
  }

}

